module.exports = __webpack_public_path__ + "img/cooperativeMedia13.567f7470.png";